import { render, staticRenderFns } from "./customerQuery.vue?vue&type=template&id=91dcffe0&"
import script from "./customerQuery.vue?vue&type=script&lang=js&"
export * from "./customerQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports